import React, { useState } from "react";

const Testimonials: React.FC = () => {
  // Sample testimonial data
  const testimonials = [
    {
      id: 1,
      name: "Asmim Khandokar ",
      role: "A Level Student, Achieved A",
      image: "",
      quote:
        "Maraz Sir's teaching methods completely transformed my understanding of chemistry. His clear explanations and problem-solving techniques helped me score in the top percentile for my O level exam.",
      year: "2024",
    },
    {
      id: 2,
      name: "Taswar Khan",
      role: "A Level Student, Achieved A*",
      image: "",
      quote:
        "I struggled with organic chemistry until I joined Maraz Sir's batch. His unique approach to teaching reaction mechanisms made everything click. I wouldn't have made it without his guidance.",
      year: "2024",
    },
    {
      id: 3,
      name: "Tanvir Rahman",
      role: "Undergraduate Student, Achieved A*",
      image: "",
      quote:
        "The way Sir explains complex concepts with simple examples is remarkable. His notes and practice materials were invaluable. I achieved an A* in Chemistry thanks to his mentorship.",
      year: "2023",
    },
    {
      id: 4,
      name: "Maliha Rahman",
      role: "Pharmacy Student, NSU`",
      image: "",
      quote:
        "Professor Maraz doesn't just teach chemistry; he instills a passion for the subject. His practical demonstrations and real-world applications made chemistry fascinating rather than intimidating.",
      year: "2022",
    },
    {
      id: 5,
      name: "Imran Hossain",
      role: "Research Assistant, USA",
      image: "",
      quote:
        "Even years after his classes, I still refer to Maraz Sir's notes. His teaching built such a strong foundation that I decided to pursue research in chemistry. He is truly an inspiration.",
      year: "2021",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  // Display 3 testimonials at a time on larger screens, 1 on mobile
  const visibleTestimonials = [];
  for (let i = 0; i < 3; i++) {
    visibleTestimonials.push(
      testimonials[(currentIndex + i) % testimonials.length]
    );
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Student Testimonials
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
            Hear from our students about their experience and success
          </p>
        </div>

        {/* Mobile Testimonial Carousel (1 at a time) */}
        <div className="md:hidden">
          <div className="bg-blue-50 rounded-xl p-6 shadow-sm">
            <div className="flex flex-col items-center text-center">
              <div className="w-20 h-20 bg-gray-200 rounded-full mb-4 flex items-center justify-center overflow-hidden">
                {testimonials[currentIndex].image ? (
                  <img
                    src={testimonials[currentIndex].image}
                    alt={testimonials[currentIndex].name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <svg
                    className="h-12 w-12 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                )}
              </div>

              <div className="relative">
                <svg
                  className="absolute top-0 left-0 transform -translate-x-6 -translate-y-8 h-16 w-16 text-blue-200 opacity-50"
                  fill="currentColor"
                  viewBox="0 0 32 32"
                  aria-hidden="true"
                >
                  <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                </svg>
                <p className="text-gray-600 italic relative z-10">
                  "{testimonials[currentIndex].quote}"
                </p>
              </div>

              <div className="mt-4">
                <h3 className="text-lg font-medium text-gray-900">
                  {testimonials[currentIndex].name}
                </h3>
                <p className="text-blue-600">
                  {testimonials[currentIndex].role}
                </p>
                <p className="text-sm text-gray-500 mt-1">
                  Class of {testimonials[currentIndex].year}
                </p>
              </div>
            </div>

            <div className="flex justify-center mt-6 space-x-3">
              <button
                onClick={prevTestimonial}
                className="p-2 rounded-full bg-white shadow hover:bg-gray-50"
              >
                <svg
                  className="h-5 w-5 text-gray-600"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <button
                onClick={nextTestimonial}
                className="p-2 rounded-full bg-white shadow hover:bg-gray-50"
              >
                <svg
                  className="h-5 w-5 text-gray-600"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Desktop Testimonials (3 at a time) */}
        <div className="hidden md:block">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {visibleTestimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-blue-50 rounded-xl p-6 shadow-sm h-full flex flex-col"
              >
                <div className="flex-grow">
                  <div className="relative">
                    <svg
                      className="absolute top-0 left-0 transform -translate-x-3 -translate-y-3 h-8 w-8 text-blue-200"
                      fill="currentColor"
                      viewBox="0 0 32 32"
                    >
                      <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                    </svg>
                    <p className="text-gray-600 italic relative z-10 pl-2">
                      "{testimonial.quote}"
                    </p>
                  </div>
                </div>

                <div className="mt-6 flex items-center">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden">
                      {testimonial.image ? (
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <svg
                          className="h-6 w-6 text-gray-400"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-base font-medium text-gray-900">
                      {testimonial.name}
                    </h3>
                    <p className="text-sm text-blue-600">{testimonial.role}</p>
                    <p className="text-xs text-gray-500">
                      Class of {testimonial.year}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-8 space-x-3">
            <button
              onClick={prevTestimonial}
              className="p-2 rounded-full bg-blue-100 hover:bg-blue-200 transition duration-300"
            >
              <svg
                className="h-6 w-6 text-blue-600"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <button
              onClick={nextTestimonial}
              className="p-2 rounded-full bg-blue-100 hover:bg-blue-200 transition duration-300"
            >
              <svg
                className="h-6 w-6 text-blue-600"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
